export enum authType {
  OTP = "OTP",
  PIN = "PIN",
  NONE = "NONE",
}

export enum authHeaders {
  Authorization = "Authorization",
}
